import { z } from "zod";
import {
  ACCOUNT_NUMBER,
  AMOUNT,
  AUTO_BILLING,
  BILLING_CATEGORY,
  BILLING_DATE,
  COMMUNITY_ID,
  CURRENCY,
  DESCRIPTION,
  DUE_DATE,
  FREQUENCY,
  INTEREST,
  MONTHLY_BILLING_DATE,
  MONTHLY_POSTING_DATE,
  PAYMENT_TERM,
  POSTING_DATE,
  PROPERTY_IDS,
  PROPERTY_CATEGORY_ID,
  TRANSACTION_TYPE,
  YEAR,
} from "./consts";

export const addSchema = z
  .object({
    [COMMUNITY_ID]: z.string().min(1, "This field is required"),
    [YEAR]: z.string().min(1, "This field is required"),
    [BILLING_CATEGORY]: z.array(z.any()).optional(),
    [TRANSACTION_TYPE]: z.string().min(1, "This field is required"),
    [AUTO_BILLING]: z.boolean().optional(),
    [ACCOUNT_NUMBER]: z.string().min(1, "This field is required"),
    [FREQUENCY]: z.string().min(1, "This field is required"),
    [AMOUNT]: z.string().min(1, "This field is required"),
    [CURRENCY]: z.string().optional(),
    [INTEREST]: z.string().optional(),
    [BILLING_DATE]: z.any().optional(),
    [POSTING_DATE]: z.any().optional(),
    [DUE_DATE]: z.any().optional(),
    [MONTHLY_BILLING_DATE]: z.any().optional(),
    [MONTHLY_POSTING_DATE]: z.any().optional(),

    // Not required by default — validation handled below
    [PAYMENT_TERM]: z.string().optional(),

    [DESCRIPTION]: z.string().optional(),
    [PROPERTY_CATEGORY_ID]: z.any().optional(),
    [PROPERTY_IDS]: z.any().optional(),
  })
  .superRefine((values, ctx) => {
    // 🔥 Conditional validation
    if (values[FREQUENCY] === "yearly" && !values[PAYMENT_TERM]) {
      ctx.addIssue({
        path: [PAYMENT_TERM],
        message: "This field is required",
        code: z.ZodIssueCode.custom,
      });
    }
  });

export type AddModelFormValues = z.infer<typeof addSchema>;
